import { render } from "./Gallery.vue?vue&type=template&id=76f43036&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=76f43036&lang=scss&scoped=true"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f43036"]])

export default __exports__